import ClientService from './services/client-service';
import ShopService from './services/shop-service';
import UrlService from './services/url-service';
import UpsellService from './services/UpsellService'
import OrderCalcService from './checkout/order-calc-service';
import ModalService from './services/modal-service';
import AgeCheckModal from './components/AgeCheckModal.vue'
import CartService from './services/cart-service'
import UiService from './services/ui-service'
import PromoService from './services/PromoService'
import growl from './services/growl';
import DataStore from './services/data-store';
import Vue from 'vue'

angular.module("eatself")
.run(function($state) {
	if (!$state.current.name && location.hostname == 'auresto.eatself.com') {
		$state.go('map-restos2');
	}
})
.config(function (
	$stateProvider,
	$urlRouterProvider,
	$titleProvider,
	) {
	$titleProvider.documentTitle(
		($rootScope) => $rootScope.$title || "EatSelf: Création site pour restaurant - Commande en ligne"
		);

	function stripTrailingSlash($injector, $location) {
		var path = $location.path();
		var hasTrailingSlash = path && path[path.length - 1] === "/";
		if (hasTrailingSlash) {
			return path.substr(0, path.length - 1) + getQueryString($location.search());
		}
	}
	function getQueryString(searchObj) {
		let searchQuery = '';
		for(let key in searchObj) {
			searchQuery += (searchQuery ? '&' : '?') + key + '=' + searchObj[key];
		}
		return searchQuery;
	}


	let adminfile = location.host == "localhost" ? "admin-localhost.html" : "admin.html";
	$urlRouterProvider
	.rule(stripTrailingSlash)
	.when("/admin*path", ($match, $location) => {
		if ($match.path.indexOf(".html") != -1) {
			return false;
		}
		location.href = adminfile + "/admin" + $match.path + getQueryString($location.search());
				// location.reload();
				return true;
			})
	.when("/manager*path", ($match) => {
		if ($match.path.indexOf(".html") != -1) {
			return false;
		}
		location.href = adminfile + "/manager" + $match.path;
				// location.reload();
				return true;
			})
	.when("/manager", "/manager/liste")
	.when("/{ShopId:\\d+}", "/{ShopId:\\d+}/accueil")
	.when("", "/not-found")
			.when("/carte", "/not-found") // carte without ShopId
			.when("/{ShopId:\\d+}/carte", "/{ShopId:\\d+}/carte/0")
			.when("/admin", "/admin/carte")
			.when("/admin/carte", "/admin/carte/0")
			.otherwise(function ($injector, $location) {
				let $state = $injector.get("$state");
				if ($state.current.name) {
					return false;
				}
				if ($location.hash()) {
					return $location.hash();
				}
				if ($location.path().search(/^\/\d+\//) != -1) {
					// remove the leading /ShopId/....
					return $location.path().split("/").slice(2).join("/");
				}
				if ($location.path().indexOf(".html") != -1) {
					// remove the leading /index.html/...
					return $location.path().split("/").slice(2).join("/");
				}
				var growl = $injector.get("growl");
				growl.error("La page '" + $location.$$path.replace(/^\//, "") + "' n'existe pas");
				// return '/accueil'
				var shop_togo = ShopService.shop || ShopService.lastShop;
				if (shop_togo) {
					return "/" + shop_togo.ShopId + "/accueil";
				} else {
					return "/not-found";
				}
			});

			$stateProvider
			.state("map-restos", {
				url: "/decouverte",
				template: "<map-restos></map-restos>",
			})
			.state("map-restos2", {
				template: "<map-restos></map-restos>",
			})
			.state("404", {
				url: "/not-found",
				template:
				'<div style="height: 100px;"></div><h1 class="text-center">Désolé, cette page n\'existe pas</h1>',
			})
			.state("inactive", {
				xurl: "pas d'url",
				template:
				'<div style="height: 100px;"></div><h1 class="text-center">Désolé, ce magasin est inactif</h1>',
			})
			.state("404bis", {
				url: "/{ShopId:\\d+}/not-found",
				template: '<h1 class="text-center">Désolé, cette page n\'existe pas</h1>',
			})
			.state("accessdenied", {
				url: "/interdit",
				template: "<h1 class='m-30'>Vous n'avez pas les droits d'accès a cette page</h1>",
			})
			.state("sitemap", {
				url: "/{ShopId:\\d+}/sitemap",
				template: '<sitemap></sitemap>',
			})
			.state("rgpd", {
				url: "/{ShopId:\\d+}/rgpd",
				template: '<rgpd></rgpd>',
				controllerAs: "vm",
				controller: function() {
					ShopService.qShop.then(shop => this.shop = shop);
				},
			})
			.state("cgv", {
				url: "/{ShopId:\\d+}/cgv",
				template: '<cgv></cgv>',
			})
			.state("contact", {
				url: "/{ShopId:\\d+}/contact",
				template: '<home-bottom></home-bottom>',
				controllerAs: "vm",
			})
			.state("page", {
				url: "/{ShopId:\\d+}/page/{PageId:\\d+}",
				template: '<page-perso v-props-page="$resolve.page"></page-perso>',
				resolve: {
					page($stateParams) {
						return ShopService.setShopIdAsync($stateParams.ShopId)
						.then(shop => shop.pages.find(page => page.id == $stateParams.PageId));
					},
				}
			})
			.state("page.current", {
				url: "/{path:.*}",
			})
			.state("ticket", {
				url: "/{ShopId:\\d+}/ticket?Total&Ticket&ntik&Table&DateService&oi",
				template: '<home shop="$resolve.shop" product-tree="$resolve.shop.productTree"></home>',
				resolve: {
					shop($stateParams) {
						return ShopService.setShopIdAsync($stateParams.ShopId);
					},
					$title(shop) {
						return _.compact([shop.DefaultName, shop.City, shop.DefaultDescription]).join(" - ");
					},
				},
				onEnter( shop, $stateParams) {
					CartService.newCart(shop);
					let cart = CartService.cart;
					cart.Total = $stateParams.Total;
					cart.Subtotal = cart.Total;
					cart.Remain = cart.Total;
					cart.PaymentAmount = +cart.Remain;
					cart.TicketId = $stateParams.Ticket;
					cart.Table = $stateParams.Table;
					cart.DateService = $stateParams.DateService;
					cart.Ntik = $stateParams.ntik;
					cart.SaleAreaId = ShopService.SALE_AREAS.TICKET;
					cart.PickupTimeDate = moment().format();
					cart.ShopId = $stateParams.ShopId;
					if ($stateParams.oi) {
						try {
							cart.oi = JSON.parse($stateParams.oi);
						} catch(err) {
							cart.oi = [ err ];
						}
					}
					OrderCalcService.recalcFees(cart);
					UiService.openTicketModal(cart);
				},
				onExit() {},
			})
			.state("salon", {
				url: "/{ShopId:\\d+}/salon?cli&societe&tel&mail&adresse&cp&ville&pays&sales&nom&prenom&siren",
				template: '<home shop="$resolve.shop" product-tree="$resolve.shop.productTree"></home>',
				resolve: {
					shop($stateParams) {
						return ShopService.setShopIdAsync($stateParams.ShopId);
					},
					$title(shop) {
						return _.compact([shop.DefaultName, shop.City, shop.DefaultDescription]).join(" - ");
					},
				},
				onEnter(shop, $stateParams) {
					CartService.newCart(shop);
					let cart = CartService.cart;
					Vue.set(cart.info2,'siren', $stateParams.siren);
					Vue.set(cart.info2,'NumCli', $stateParams.cli);
					Vue.set(cart.info2,'company', $stateParams.societe);
					Vue.set(cart.info2,'mobile', $stateParams.tel);
					Vue.set(cart.info2,'email', $stateParams.mail);
					Vue.set(cart.info2,'address', $stateParams.adresse);
					Vue.set(cart.info2,'zip', $stateParams.cp);
					Vue.set(cart.info2,'city', $stateParams.ville);
					Vue.set(cart.info2,'country', $stateParams.pays);
					Vue.set(cart.info2,'firstName', $stateParams.prenom);
					Vue.set(cart.info2,'lastName', $stateParams.nom);
					Vue.set(cart.info2,'commercialEmail', $stateParams.sales);
				},
				onExit() {},
			})
			.state('booking', {
				url: '/{ShopId:\\d+}/booking',
				template: '<home shop="$resolve.shop" product-tree="$resolve.shop.productTree"></home>',
				onEnter() {
					UiService.showReservationModal();
				},
				resolve: {
					shop($stateParams) {
						return ShopService.setShopIdAsync($stateParams.ShopId);
					},
				}
			})
			.state("landing", {
				url: "/{ShopId:\\d+}/accueil?Table&Promo",
				template: '<home shop="$resolve.shop" product-tree="$resolve.shop.productTree"></home>',
				resolve: {
					shop($stateParams) {
						return ShopService.setShopIdAsync($stateParams.ShopId);
					},
					$title(shop) {
						return _.compact([shop.DefaultName, shop.City, shop.DefaultDescription]).join(" - ");
					},
				},
				onEnter(shop, $stateParams, $state) {
					if (!shop) {
						$state.go("404");
					}
					if (!CartService.cart) {
						console.error('no cart, but shop is loaded !')
					}
					if ($stateParams.Promo) {
						let cart = CartService.cart;
						let promos = PromoService.usablePromoCodes();
						let promo = _.find(promos,(promo) => promo.Code == $stateParams.Promo)
						if (promo) {
							PromoService.setPromoCode(promo, cart);
							// dont remove the param
							// let url = new URL(location);
							// url.searchParams.delete("Promo");
							// history.replaceState({}, "", url);
							if (promo.Message) {
								growl.info(promo.Message);
							}
						} else {
							// not valid ?
						}
					}
					if ($stateParams.Table) {
						CartService.setRestoMode($stateParams.Table);
					}
					if (shop.info.display.hideOrderButtons) {
						UiService.showReservationModal();
					}
					if (shop.info.ageCheck) {
						if (!CartService.cart.ageConfirmed) {
							ModalService.open(AgeCheckModal, {}, {},['backdrop-blur-10']);
						}
					}
				},
			})
			.state("carte", {
				url: "/{ShopId:\\d+}/carte/{tid:\\d+}?Table&start",
				params: {
					"#": "",
				},
				template: `<eatself-carte item="$resolve.item" shop="$resolve.shop"></eatself-carte>`,
				reloadOnSearch: true,
				resolve: {
					item($stateParams, shop) {
						return ShopService.getItem($stateParams.tid, shop.productTree);
					},
					shop($stateParams,$q) {
						if (ShopService.shop && ShopService.shop.ShopId == $stateParams.ShopId) {
							return ShopService.shop;
						}
						let p = ShopService.setShopIdAsync($stateParams.ShopId);
						let d = $q.defer();
						p.then(v=>d.resolve(v)).catch(e=>d.reject(e));
						return d.promise;
					},
					$title(shop, item) {
						return _.compact([shop.DefaultName, shop.City, item.product.dn]).join(" - ");
					},
				},
				onEnter(shop) {
					// THIS FUNCTION IS EXEC'D TWICE: for carte, and for carte/0
					if (shop.info.ageCheck) {
						if (!CartService.cart.ageConfirmed) {
							ModalService.open(AgeCheckModal,{},{},['backdrop-blur-10']);
						}
					}
				}
			})
			.state("formule", {
				url: "/{ShopId:\\d+}/formule/{pid:\\d+}",
				template: `<eatself-carte item="$resolve.item" shop="$resolve.shop"></eatself-carte>`,
				reloadOnSearch: true,
				onEnter($stateParams) {
					if (!UpsellService.cartMenu) {
						let item = ShopService.getItemFromPid($stateParams.pid, ShopService.shop.productTree);
						UrlService.go({name:'carte',params:{ShopId: ShopService.shop.ShopId, tid: item.tid }});
					}
				},
				resolve: {
					item($stateParams, shop) {
						let ProductId = $stateParams.pid;
						let product = shop.products[ProductId];
						let menu = shop.products[product.upsell_to];
						return { product: menu };
					},
					shop($stateParams,$q) {
						if (ShopService.shop && ShopService.shop.ShopId == $stateParams.ShopId) {
							return ShopService.shop;
						}
						let p = ShopService.setShopIdAsync($stateParams.ShopId);
						let d = $q.defer();
						p.then(v=>d.resolve(v)).catch(e=>d.reject(e));
						return d.promise;
					},
				},
			})
			.state("recrutement", {
                url: "/{ShopId:\\d+}/fidelite/recrutement",
                template: '<recrutement v-props-shop="$resolve.shop"></recrutement>',
                resolve: {
                    shop: ($stateParams) => ShopService.setShopIdAsync($stateParams.ShopId),
                },
            })
            .state("register-card", {
                url: "/{ShopId:\\d+}/fidelite/register-card",
                template: '<fidelity-inscription></fidelity-inscription>',
            })
            .state("update-card", {
                url: "/{ShopId:\\d+}/fidelite/update-card",
                params: {
                    card: null,
                },
                controllerAs: "vm",
                controller: function($stateParams) {
                    this.card = $stateParams.card;
                    this.client = DataStore.normalizeClientData(this.card?.client || {});
                },
                template: '<update-fidelite-card v-props-card="vm.card" v-props-client="vm.client"></update-fidelite-card>',
                resolve: {
                    shop: ($stateParams) => ShopService.setShopIdAsync($stateParams.ShopId),
                    $title: (shop) => shop.DefaultName + " - Carte de fidélité",
					// card: ($stateParams) => $stateParams.card,
					// client: ($stateParams) =>
                },
            })
            .state("fid-card-link", {
                url: "/{ShopId:\\d+}/fidelite/card-link/{data}",
                template: '<fidelite-card-link></fidelite-card-link>',
                controllerAs: "vm",
                resolve: {
                    shop: ($stateParams) => ShopService.setShopIdAsync($stateParams.ShopId),
                    $title: (shop) => shop.DefaultName + " - Carte de fidélité",
                },
            })
			.state("client-details", {
				url: "/{ShopId:\\d+}/client/details",
				template: '<client-details></client-details>',
				resolve: {
					authorize() {
						return ClientService.requestLoginAsync();
					},
				}
			})
			.state("confirmed", {
				url: "/{ShopId:\\d+}/confirmed?OrderId",
				template: '<order-confirmed order="vm.order" shop-id="vm.ShopId"></order-confirmed>',
				controllerAs: "vm",
				params: {
					order: null,
				},
				controller: function($stateParams) {
					this.order = $stateParams.order;
					this.ShopId = $stateParams.ShopId;
				},
			})
			.state("client-orders", {
				url: "/{ShopId:\\d+}/client/orders",
				template: '<orders-split-list-view></orders-split-list-view>',
			})
			.state("client-orders.current", {
				url: "/:OrderId",
				params: {
					order: null,
					isOrderConfirmation: false,
				},
			})
			.state("rappel", {
				url: "/{ShopId:\\d+}/rappel",
				template: `<carnet-covid19></carnet-covid19>`,
			})
			.state('rappel-done',{
				params: {
					ShopId: null,
				},
				template: "<rappel-done />",
				})
		});
